// extracted by mini-css-extract-plugin
export var localeSelector = "_7n-0";